import React from 'react';
import { FormProvider } from 'react-hook-form';

/* Components */
import ConversionFlowComponentRenderer from './ConversionFlowComponentRenderer';
import ConversionFlowSubmit from './ConversionFlowSubmit';
import ConversionFlowSummary from './ConversionFlowSummary';

export default function ConversionFlowForm({ form, flow, status, doRequest, handleClose }) {

    return (
        <form noValidate onSubmit={form.handleSubmit(() => doRequest({ action: 'submit' }, 'submitting'))}>
            <div className="container">
                <FormProvider {...form}>
                    <div className="row gx-8 g-xl-12 justify-content-between">
                        {flow?.form?.title ?
                            <>
                                {flow?.summary && (
                                    <div className="flow-summary-wrapper col-12 col-lg-6 col-xl-4">
                                        <ConversionFlowSummary summary={flow?.summary} status={status} />
                                    </div>
                                )}
                                <div className={`col-12 col-lg-5 ${ flow?.summary ? 'col-lg-5' : '' }`}>
                                    <div className={`card bg-white p-6 p-lg-10${status === 'loading' ? ' flow__loading' : ''}`}>
                                        <div className="row gx-4 gy-4 gy-lg-8">
                                            {(flow?.form?.title || flow?.form?.intro) && (
                                                <div className="col-12">
                                                    {flow?.form?.title && (
                                                        <p className={`h4 ${flow?.form?.intro ? 'mb-2' : 'mb-0'}`}>{flow.form.title}</p>
                                                    )}
                                                    {flow?.form?.intro && (
                                                        <p className="text-sm">{flow.form.intro}</p>
                                                    )}
                                                </div>
                                            )}

                                            <ConversionFlowComponentRenderer
                                                flow={flow}
                                            />

                                            {flow?.form?.buttonLabel && (
                                                <div className="col-12">
                                                    <ConversionFlowSubmit
                                                        className={'w-100 d-flex justify-content-center'}
                                                        flow={flow}
                                                        handleClose={handleClose}
                                                    />
                                                </div>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            <div className="flow__loader">
                                <div className="loader"></div>
                            </div>
                        }
                    </div>
                </FormProvider>
            </div>
        </form>
    );
}
